export * from './middleware/agent/browser-agent'
export * from './middleware/base'
export * from './middleware/debug'
export * from './middleware/defaultOptionsProcessor'
export * from './middleware/defaultOptionsValidator'
export * from './middleware/headers'
export * from './middleware/httpErrors'
export * from './middleware/injectResponse'
export * from './middleware/jsonRequest'
export * from './middleware/jsonResponse'
export * from './middleware/mtls'
export * from './middleware/observable'
export * from './middleware/progress/browser-progress'
export * from './middleware/promise'
export * from './middleware/proxy'
export * from './middleware/retry/browser-retry'
export * from './middleware/urlEncoded'
export type * from './types'

import {agent} from './middleware/agent/browser-agent'
import {buildKeepAlive} from './middleware/keepAlive'
/** @public */
export const keepAlive = buildKeepAlive(agent)
